/* eslint-disable jsx-a11y/no-static-element-interactions, react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as homeShape from '../../home/constants/PropTypesShapes';
import { QuestionAlt } from '../../refundHelp/constants/svgSet';
import i18n from '../../lib/reacti18n';
import * as Page from '../../lib/page';
import contentHelper from '../../lib/contentHelper';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import { elmoTreatmentNames, isPartOfElmoExpTreatment } from '../../lib/experiments-helper';

const redirectURL = '/smarthelp/article/faq1852';
const redirectClass = 'dispute-status-link';

const label = {
  disputeInfo: i18n.message('disputeHelp/disputeHelp.dispute.alert.info'),
};

class DisputeAlert extends Component {
  static getMarkup(content) {
    return { __html: content };
  }

  static getAlertInfo() {
    return contentHelper(label.disputeInfo, { user: Page.getUserFirstName(), link: redirectURL });
  }

  static linkClickHandler(e) {
    e.preventDefault();
    if (e.target.className === redirectClass) {
      const pageId = Page.isContactUsPage() ? 'disputeContactInfo' : 'disputeSearchInfo';
      trackLink({ id: pageId, link: 'dispute-info|link|click', name: Page.getPageName() });
      window.open(redirectURL, '_self');
    }
  }

  static renderDisputeAlert() {
    return (
      <div className="transaction-help__alert-container">
        <div className="transaction-help__alert-icon">
          {QuestionAlt()}
        </div>
        <div className="transaction-help__alert-content">
          <span
            onClick={DisputeAlert.linkClickHandler}
            dangerouslySetInnerHTML={DisputeAlert.getMarkup(DisputeAlert.getAlertInfo())}
          />
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    // pending dispute elmo doesn't exist in prevProps
    const prevPropsElmo = isPartOfElmoExpTreatment(prevProps.elmoTreatment, elmoTreatmentNames.pendingDisputesNotification);

    // when moving from, article page to search Pgae prevPropsElmo is not resetting and pageName is not updating
    if (((Page.isArticlePage() && prevPropsElmo) || !prevPropsElmo) && this.elmoValidation() && this.hasTransaction() && !this.getCurrentPageName()) {
      const pageId = Page.isContactUsPage() ? 'disputeContactInfo' : 'disputeSearchInfo';
      trackPage({ id: pageId, name: Page.getPageName(), link: 'dispute-alert' });
    }
  }

  getCurrentPageName() {
    // Hiding Dispute Alert for Article, Home and Topic page
    const { location } = this.props;
    if (location && location.pathname) {
      return (location.pathname.indexOf('home') >= 0 || location.pathname.indexOf('article') >= 0 ||
        location.pathname.indexOf('topic') >= 0);
    }
    return false;
  }

  hasTransaction() {
    const { disputes } = this.props;
    return Array.isArray(disputes) && disputes.length > 0;
  }

  elmoValidation() {
    const { elmoTreatment } = this.props;
    return isPartOfElmoExpTreatment(elmoTreatment, elmoTreatmentNames.pendingDisputesNotification);
  }

  render() {
    const { disputes, elmoTreatment, selectedLayer } = this.props;
    // Elmo Treatment check
    const elmoResource = isPartOfElmoExpTreatment(elmoTreatment, elmoTreatmentNames.pendingDisputesNotification);
    const layer = (selectedLayer && selectedLayer.layer) ? selectedLayer.layer : null;

    if (!disputes.length || this.getCurrentPageName() || !elmoResource || layer > 1) {
      // checking whether disputes exist or not and not showing the disputes message on article page and home page
      // And blocking dispute alert when user is in L2 for contact-us page
      return null;
    }
    return DisputeAlert.renderDisputeAlert();
  }
}

DisputeAlert.propTypes = {
  disputes: PropTypes.shape(homeShape.OPEN_CASE),
  elmoTreatment: PropTypes.shape(homeShape.ELMO_TREATMENT),
};

DisputeAlert.defaultProps = {
  disputes: [],
  elmoTreatment: [],
};

const mapStateToProps = state => ({
  disputes: state.openCase.cases,
  elmoTreatment: state.app.elmoTreatments,
  selectedLayer: state.topicSelect,
  location: state.location,
});

export default connect(mapStateToProps)(DisputeAlert);
